import { useQuery } from '@apollo/client/react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { TextField, Autocomplete, Checkbox, Grid } from '@mui/material';
import { filter } from 'lodash';
import { useContext } from 'react';

import { KickOffContext } from '@/Contexts/KickOff';
import { GetCompanyTagsDocument } from '@/graphql/generated/graphql';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ProjectTags: React.FC = () => {
  const { projectTagIds, setProjectTagIds } = useContext(KickOffContext);
  const { data } = useQuery(GetCompanyTagsDocument);

  return (
    <Grid size={12} mt={1}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        fullWidth
        id="project-tag-selector"
        options={data?.getCompanyTags || []}
        value={filter(data?.getCompanyTags || [], (tag) => projectTagIds && projectTagIds.includes(tag.id)) || []}
        onChange={(_, newValue) => {
          setProjectTagIds(newValue.map((tag) => tag.id as string));
        }}
        getOptionLabel={(option) => option.title}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={`selectedTags-${option.id}`}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
            {option.title}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Tags" placeholder="Select Tag" />}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
    </Grid>
  );
};

export default ProjectTags;
